import { Link } from 'react-router-dom';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';
import { POLICY_UPDATED } from '@/shared/policy';
import { useSeo } from '@/shared/seo';

export default function PolicyDoc({ doc }) {
  useSeo({ title: doc.title, description: doc.summary });

  return (
    <article className="mx-auto max-w-3xl px-4 py-10 md:px-8 md:py-16">
      <Button variant="ghost" size="sm" asChild>
        <Link to="/">
          <ApperIcon name="ArrowLeft" size={16} />
          Back to Ghost Cable
        </Link>
      </Button>
      <p className="mt-8 text-[11px] uppercase tracking-[0.24em] text-primary">{doc.label}</p>
      <h1 className="mt-2 font-heading text-5xl leading-none md:text-6xl">{doc.title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">Updated {POLICY_UPDATED}</p>
      {doc.summary && (
        <p className="mt-8 rounded-lg border border-highlight/30 bg-highlight/10 p-4 text-sm leading-6">{doc.summary}</p>
      )}
      <div className="mt-10 space-y-10">
        {doc.sections.map((s, i) => (
          <section key={s.h ?? i}>
            <h2 className="flex items-baseline gap-3 text-lg font-semibold">
              <span className="font-heading text-2xl text-primary">{i + 1}</span>
              {s.h}
            </h2>
            <div className="mt-3 space-y-3 text-[15px] leading-7 text-muted-foreground">
              {s.p.map((para, j) => (
                <p key={j}>{para}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
      {doc.signoff && <p className="mt-12 font-heading text-2xl text-primary">{doc.signoff}</p>}
    </article>
  );
}
